import { PROFILE_ATTRIBUTES } from '../data/criteria';
const STORAGE_KEY = 'decidepro-user-profile-v1';
export function getStoredProfile() {
    try {
        const data = localStorage.getItem(STORAGE_KEY);
        return data ? JSON.parse(data) : null;
    }
    catch {
        return null;
    }
}
export function saveProfile(profile) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(profile));
}
export function createDefaultProfile() {
    const now = new Date().toISOString();
    return {
        id: crypto.randomUUID(),
        name: 'Meu Perfil',
        attributes: PROFILE_ATTRIBUTES.map(attr => ({
            attributeId: attr.id,
            value: attr.type === 'select' && attr.id === 'motivation' ? 'freedom' : 5,
        })),
        createdAt: now,
        updatedAt: now,
    };
}
export function getAttributeById(id) {
    return PROFILE_ATTRIBUTES.find(a => a.id === id);
}
export function getAttributesByCategory(category) {
    return PROFILE_ATTRIBUTES.filter(a => a.category === category);
}
